<template>
    <div>
        <DatePicker />
        <el-row :gutter="10" >
            <NewSignups />
            <!-- <Videos />
            <Tracks /> -->
        </el-row>
    </div>
</template>
  
<script>

import NewSignups from '@/modules/admin/cms/components/youtube/dashboard/NewSignups.vue'
// import Videos from '@/modules/admin/dashboard/components/Videos'
// import Tracks from '@/modules/admin/dashboard/components/Tracks'
import DatePicker from '@/modules/admin/cms/components/youtube/dashboard/DatePicker'
export default {
components: {
    DatePicker,
    NewSignups,
    // Videos,
    // Tracks,
}
}
</script>
  
<style lang="scss">
    .statistic-graph {
        .el-card__body {
            height: 330px;
        }
        .card-header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            &__title {
            display: flex;
            align-items: center;
            }

            &__filter {
            width: 150px;
            display: grid;
            justify-content: center;
            }
        }
    }
</style>
  